import Rollbar, { Configuration } from 'rollbar';

import { Injectable, InjectionToken, ErrorHandler, inject } from '@angular/core';
import { environment } from '@dps/env';
import { AuthStore } from '../store';

const rollbarConfig = {
  accessToken: 'aa41db0a03e146f6bf997139e05b6fb3',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment.envName,
  codeVersion: '1',
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
} satisfies Configuration;

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  private rollbar = inject<Rollbar>(RollbarService);
  private authStore = inject(AuthStore);

  constructor() {
    this.authStore.getCurrUserData$().subscribe(currUser =>
      this.rollbar.configure({
        payload: {
          currUser,
        },
      })
    );
  }

  handleError(err: any): void {
    console.error(err);
    this.rollbar.error(err.originalError || err);
  }
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}
